import { render } from "./FriendsItem.vue?vue&type=template&id=7124299c&scoped=true"
import script from "./FriendsItem.vue?vue&type=script&lang=js"
export * from "./FriendsItem.vue?vue&type=script&lang=js"

import "./FriendsItem.vue?vue&type=style&index=0&id=7124299c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7124299c"]])

export default __exports__